import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { PortDetailsService } from 'src/app/shared/service/port-details/port-details.service';
import { getSegmentOptions } from 'src/app/shared/helpers/Drop-down-options';
import { FormPopupComponent } from './pages/form-popup/form-popup.component';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { WeatherFactorPopupComponent } from './pages/form-popup/weather-factor-popup/weather-factor-popup.component';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  pairwise,
  skip,
} from 'rxjs';
import { PortsPopupComponent } from './pages/ports-popup/ports-popup.component';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';

@Component({
  selector: 'app-request-form',
  templateUrl: './request-form.component.html',
  styleUrls: ['./request-form.component.scss'],
})
export class RequestFormComponent {
  requestForm!: FormGroup;
  formSubmitted: boolean = false;
  clientOptions: any;
  portNameSuggestions: any[] = [];
  filteredPortNames: any[] = [];
  shipyardOptions = ['TBD'];
  merakiPicOptions = [
    { label: 'AAY - Aayush Singh Parmar', value: 'AAY' },
    { label: 'AMA - Amrit Anand', value: 'AMA' },
    { label: 'ANKU - Usha Kumari', value: 'ANKU' },
    { label: 'AJK - Ajeet Kumar', value: 'AJK' },
    { label: 'DEB - Deepika Bhardwaj', value: 'DEB' },
    { label: 'GMK - Gaurav Mohan Kulkarni', value: 'GMK' },
    { label: 'GUS - Gurvinder Singh', value: 'GUS' },
    { label: 'HAS - Harshi Jain', value: 'HAS' },
    { label: 'KER - Keerthana Rajamani', value: 'KER' },
    { label: 'KPJ - Kinshuk Pragya Jha', value: 'KPJ' },
    { label: 'MAL - Malini Sivaranjini', value: 'MAL' },
    { label: 'MNG - Manisha Ganesh', value: 'MNG' },
    { label: 'NAB - Nancy Baidya', value: 'NAB' },
    { label: 'PHJ - Philomina Johnthomas', value: 'PHJ' },
    { label: 'STP - Shatakshi Priya', value: 'STP' },
    { label: 'SNK - Sonu Kumar', value: 'SNK' },
    { label: 'SOS - Souta Samanta', value: 'SOS' },
    { label: 'SUTH - Suman Saurav Thakur', value: 'SUTH' },
  ];
  // merakiPicOptions = [
  //   { label: 'ALS - Alexroger', value: 'ALS' },
  //   { label: 'ANKU', value: 'ANKU' },
  //   { label: 'HAJ - Hancy', value: 'HAJ' },
  //   { label: 'HAS - Harshi', value: 'HAS' },
  //   { label: 'KER - Keerthana', value: 'KER' },
  //   { label: 'INV - Indhirani', value: 'INV' },
  //   { label: 'MAL - Malini', value: 'MAL' },
  //   { label: 'PHJ - Philomina', value: 'PHJ' },
  //   { label: 'PRA - Priya', value: 'PRA' },
  //   { label: 'RAS - Rajeswari', value: 'RAS' },
  //   { label: 'SAG - Santhosh', value: 'SAG' },
  //   { label: 'SOS - Souta Samanta ', value: 'SOS' },
  //   { label: 'SUTH-Saurav_Thakur', value: 'SUTH' },
  //   { label: 'BHY - Bhargavi', value: 'BHY' },
  //   { label: 'NAB - Nancy', value: 'NAB' },
  //   { label: 'DEKA - Deepika', value: 'DEKA' },
  //   { label: 'ARYA - Arbaaz', value: 'ARYA' },
  //   { label: 'HRIT - Hritik', value: 'HRIT' },
  //   { label: 'NIMA- Niharika Mahajan', value: 'NIMA' },
  //   { label: 'TST - Test', value: 'TST' },
  // ];
  weatherSourceOptions = [
    { label: 'DTN', value: 'DTN' },
    { label: 'Storm Glass', value: 'stormglass' },
  ];
  eigerPicOptions = [
    { label: 'SAKA - Satish', value: 'SAKA' },
    { label: 'SABA - Sandokan', value: 'SABA' },
    { label: 'ROAK - Roman', value: 'ROAK' },
    { label: 'AAHA - Ahmet', value: 'AAHA' },
    { label: 'NIAL - Nikita', value: 'NIAL' },
    // { label: 'JESH - Jeet', value: 'JESH' },
    { label: 'RAPA - Rahul', value: 'RAPA' },
    { label: 'AHKM - Abhishek', value: 'AHKM' },
    { label: 'SAMH - Sadique Muhammad', value: 'SAMH' },
    { label: 'ALYI - Alex', value: 'ALYI' },
    { label: 'KHGL - Khazar Guliyev', value: 'KHGL' },
  ];
  segmentOptions: { label: string; value: string }[] = [];
  typeOfSpeedOptions = [
    { label: 'Constant Speed', value: 'CP Speed' },
    {
      label: 'Optimal Speed(Reefer container)',
      value: 'Optimal Speed(Reefer container)',
    },
    { label: 'Optimal Speed', value: 'Optimal Speed' },
    { label: 'constant speed (new methodology)', value: 'newmethodology' },
  ];
  voyageTypeOptions = [
    { label: 'Laden', value: 'Laden' },
    { label: 'Ballast', value: 'Ballast' },
  ];
  reportTypeOptions = [
    { label: 'Mid Voyage', value: 'MID' },
    { label: 'End Voyage', value: 'END' },
  ];
  fuelMethodOptions = [
    { label: 'Single Fuel', value: 'Single' },
    { label: 'Dual Fuel', value: 'Dual' },
  ];
  yesNo = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  weatherfactorOptions = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  yesNoDayPositive = [
    { label: 'Yes', value: 'all_day_positive' },
    { label: 'No', value: 'no' },
  ];
  duelFuelOptions = [
    { label: 'Yes', value: 'excluded' },
    { label: 'No', value: 'included' },
  ];
  adverseCurrentValue = [
    { label: 'Yes', value: 'x' },
    { label: 'No', value: 'inc' },
  ];
  yesNo3 = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
    { label: 'N/A', value: 'Not Applicable' },
  ];
  wetherCalculationOptions = [
    { label: 'BF Only', value: 'BF' },
    { label: 'DSS', value: 'DSS' },
    { label: 'SWH', value: 'SWH' },
    { label: 'SWH&DSS', value: 'SWH+DSS' },
    { label: 'Wind Wave & Swell Height', value: 'Wind Wave & Swell Height' },
  ];
  performanceCalOptions = [
    { label: 'Voyage', value: 'Voyage' },
    { label: 'Daily', value: 'Daily' },
  ];
  templetOptions = [
    { label: 'Weather Report', value: 'weather_report' },
    // { label: 'Ballast', value: 'Ballast' },
  ];
  formatOptions = [
    { label: 'New', value: 'new' },
    { label: 'Old', value: 'old' },
  ];
  typeofshipOptions = [
    { label: 'Bulk carrier', value: 'Bulk carrier' },
    { label: 'Container ship', value: 'Container ship' },
    { label: 'General cargo', value: 'General cargo' },
    { label: 'Passenger ship', value: 'Passenger ship' },
    { label: 'Tanker', value: 'Tanker' },
    { label: 'Gas Tanker', value: 'Gas Tanker' },
  ];
  segmentMapping: { [key: string]: { label: string; value: string }[] } = {
    'Bulk carrier': [
      { label: 'Coaster', value: 'Coaster' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'Handymax', value: 'Handymax' },
      { label: 'Supramax', value: 'Supramax' },
      { label: 'Ultramax', value: 'Ultramax' },
      { label: 'Panamax', value: 'Panamax' },
      { label: 'Kamsarmax', value: 'Kamsarmax' },
      { label: 'post-Panamax', value: 'post-Panamax' },
      { label: 'Capesize', value: 'Capesize' },
      { label: 'Very Large Ore Carrier', value: 'VLOC' },
      { label: 'Chinamax', value: 'Chinamax' },
    ],
    Tanker: [
      { label: 'Coastal', value: 'Coastal' },
      { label: 'Intermediate', value: 'Intermediate' },
      { label: 'Handytankers', value: 'Handytankers' },
      { label: 'MR2', value: 'MR2' },
      { label: 'LR1 / Panamax', value: 'LR1/Panamax' },
      { label: 'LR2 / Aframax', value: 'LR2/Aframax' },
      { label: 'LR3 / Suezmax', value: 'LR3/Suezmax' },
      { label: 'VLCC', value: 'VLCC' },
    ],
    'Gas Tanker': [
      { label: 'Coasters', value: 'Coasters' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'MGC', value: 'MGC' },
      { label: 'LGC', value: 'LGC' },
      { label: 'VLGC', value: 'VLGC' },
      { label: 'VLEC', value: 'VLEC' },
    ],
    'Container ship': [],
    'General cargo': [
      { label: 'Coaster', value: 'Coaster' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'Handymax', value: 'Handymax' },
      { label: 'Supramax', value: 'Supramax' },
      { label: 'Ultramax', value: 'Ultramax' },
      { label: 'Panamax', value: 'Panamax' },
      { label: 'Kamsarmax', value: 'Kamsarmax' },
      { label: 'post-Panamax', value: 'post-Panamax' },
      { label: 'Capesize', value: 'Capesize' },
      { label: 'Very Large Ore Carrier', value: 'VLOC' },
      { label: 'Chinamax', value: 'Chinamax' },
    ],
    'Passenger ship': [],
  };
  goodWeatherPeriod = ['12', '15', '18', '24'];
  windBeaufort = ['2', '3', '4', '5', '6'];
  fuelType = ['ULSFO', 'VLSFO', 'HSFO', 'MDO', 'LNG', 'OTHERS', 'NA'];
  selectedFile!: File;
  selectedMainCPFile!: File;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  @ViewChild('fileUpload') fileUpload: ElementRef | undefined;
  datesValidator: boolean = false;
  isForm: boolean = false;
  latDir = ['N', 'S'];
  longDir = ['E', 'W'];
  id: any;
  reportType: any;
  fileType: 'excel' | 'json' = 'excel';
  cospOptions: Array<{ label: string; value: string }> = [];
  eospOptions: Array<{ label: string; value: string }> = [];

  cospEvents: any[] = [];
  eospEvents: any[] = [];
  cospDropdownList: string[] = [];
  eospDropdownList: string[] = [];

  reportGenerate: boolean = false;
  mainCpFile: boolean = false;
  dataToPass: any;
  selectedRequestformFile: any;
  previousValue: any;
  weatherFactor: boolean = false;
  imoNumber: any;
  voyageNumber: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
    private router: Router,
    private portDetails: PortDetailsService,
    private dialog: MatDialog,
    private overlayService: OverlapService,
    private route: ActivatedRoute,
    private prequestFormService: PortRequestFormServiceService,
  ) {
    this.requestForm = this.fb.group({
      merakiPic: ['', Validators.required],
      ship: ['', Validators.required],
      imoNumber: ['', [Validators.required, Validators.pattern(/^\d{7}$/)]],
      voyNumber: [''],
      typeOfShip: ['', Validators.required],
      segment: ['', Validators.required],
      eigerPic: [''],
      shipYard: [''],
      yearBuilt: [''],
      pFrom: ['', Validators.required],
      pTo: ['', Validators.required],
      etaDate: [''],
      etaHours: [''],
      etaMinutes: [''],
      cosp: [''],
      cospHours: [''],
      cospMinutes: [''],
      eosp: [''],
      eospHours: [''],
      eospMinutes: [''],
      client: ['', Validators.required],
      templet: [''],
      zn_format: [''],
      weatherSource: ['', Validators.required],
      typeSpeed: ['', Validators.required],
      voyageType: ['', Validators.required],
      reportType: ['', Validators.required],
      fuelMethod: ['Single', Validators.required],
      cpOrderedSpeed: ['', Validators.required],
      claimable: [false],
      allDayPositive: [''],
      multipleSpeed: [false],
      fuelType: ['', Validators.required],
      fuelTypeOne: ['', Validators.required],
      fuelTypeTwo: ['', Validators.required],
      cpFuel: [''],
      cpFuelOne: [''],
      cpOthers: [''],
      aboutSc: ['', Validators.required],
      windBeaufort: ['', Validators.required],
      windWave: ['', Validators.required],
      swellHeight: ['', Validators.required],
      significantWave: ['', Validators.required],
      adverseCurrent: ['', Validators.required],
      currentFactor: ['', Validators.required],
      weatherFactor: [''],
      periodiccurrentfactor: ['', Validators.required],
      currentOnlyNeg: [''],
      adverseSwellEx: [''],
      hoursNeedToBeCon: [false],
      goodWeatherPeriod: ['', Validators.required],
      performanceCal: ['', Validators.required],
      excludeFirst: [''],
      excludeLast: [''],
      speedMinTol: ['', Validators.required],
      speedMaxTol: ['', Validators.required],
      speedMinTolPercentage: [false],
      speedMaxTolPercentage: [false],
      consMinTol: ['', Validators.required],
      consMaxTol: ['', Validators.required],
      extrapolationMethod: ['', Validators.required],
      wetherCalculation: ['', Validators.required],
      secaEca: [''],
      duelFuel: ['', Validators.required],
      cpGasOil: [''],
      useNewCurrentFormula: ['NO'],
      bfLimitDss: ['', Validators.required],
      // mainCp: ['', Validators.required],
      currLat: [''],
      currLng: [''],
      latDir: [''],
      longDir: [''],
      reportedDate: ['', Validators.required],
      reportedHours: [''],
      reportedMinutes: [''],
      repWindBf: [''],
      repSwell: [''],
      repAvgSpeed: [''],
      voyAvgSpeed: [''],
      mainCp: ['', [this.maxWordsValidator()]],
      mainCpFile: [''],
      additionalComments: [''],
      id: [''],
      updatedAt: [''],
      status: [''],
      uniqueVoyId: [''],
      has_mid_voyage: [false],
      lock_until_date: [''],
      ship_length: [''],
      ship_breadth: [''],
      windage_area: [''],
      power: [''],
      wind_drag_coef: [''],
      air_density: [''],
      empirical_constant: ['0.01'],
    });

    this.requestForm.get('client')?.valueChanges.subscribe((value) => {
      console.log('condition', this.requestForm.value);
      if (value === 'ZeroNorth') {
        if (!this.requestForm.get('zn_format')?.value) {
          this.requestForm.get('zn_format')?.setValue('new');
        }
      }
      if (value === 'Eiger') {
        this.weatherFactor = true;
        this.requestForm.patchValue({ periodiccurrentfactor: 'NO' });
      } else {
        this.weatherFactor = false;
        this.requestForm.patchValue({ periodiccurrentfactor: 'YES' });
      }
    });
    let firstChangeHandled = false;
    this.requestForm
      .get('weatherFactor')
      ?.valueChanges.pipe(distinctUntilChanged())
      .subscribe((value) => {
        const shipLengthValue = this.requestForm.get('ship_length')?.value;
        if (this.id && !firstChangeHandled) {
          firstChangeHandled = true;
          return;
        }

        if (!this.id) {
          if (value) {
            this.openPopup();
          }
        } else if (this.id) {
          if (value) {
            this.openPopup();
          }
        }

        this.previousValue = value;
      });
    if (!this.id) {
      this.setupAutoApiCall();
    }
  }
  openPopup() {
    const dialog = this.dialog.open(WeatherFactorPopupComponent, {
      width: '800px',
      height: '500px',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      if (result) {
        console.log(JSON.stringify(result));
        const parsedResult =
          typeof result === 'string' ? JSON.parse(result) : result;
        this.requestForm.get('ship_length')?.setValue(parsedResult.ship_length);
        this.requestForm
          .get('ship_breadth')
          ?.setValue(parsedResult.ship_breadth);
        this.requestForm
          .get('windage_area')
          ?.setValue(parsedResult.windage_area);
        this.requestForm.get('power')?.setValue(parsedResult.power);
        this.requestForm
          .get('wind_drag_coef')
          ?.setValue(parsedResult.wind_drag_coef);
        this.requestForm.get('air_density')?.setValue(parsedResult.air_density);
        this.requestForm
          .get('empirical_constant')
          ?.setValue(parsedResult.empirical_constant);
      }
    });
  }
  setupAutoApiCall() {
    this.requestForm
      .get('imoNumber')
      ?.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((imoNumber) => {
        const ship = this.requestForm.get('ship')?.value;

        if (imoNumber && imoNumber.length === 7) {
          this.callRetrieveReport(ship, imoNumber);
        }
      });
  }
  callRetrieveReport(ship: string, imoNumber: string) {
    if (!this.id) {
      this.requestFormService.getFormDetails(ship, imoNumber).subscribe({
        next: (data) => {
          this.id = data?.id;
          if (data?.id) {
            // this.reportGenerate = true;

            const cospDate = data.cosp.split(' ') || [];
            const eospDate = data.eosp.split(' ') || [];
            const ETAdate = data.etaDate.split(' ') || [];
            const reportedDate = data.time_of_report?.split(' ') || [];
            this.requestForm.patchValue(data);
            const newFormulaVal = data?.useNewCurrentFormula || data?.usenewcurrentformula;
            if (newFormulaVal) {
              this.requestForm.get('useNewCurrentFormula')?.setValue(newFormulaVal);
            }
            // if (data.speedMinTolPercentage === 'false') {
            //   this.requestForm.get('speedMinTolPercentage')?.setValue(false);
            // } else {
            //   this.requestForm.get('speedMinTolPercentage')?.setValue(true);
            // }
            // if (data.speedMaxTolPercentage === 'false') {
            //   this.requestForm.get('speedMaxTolPercentage')?.setValue(false);
            // } else {
            //   this.requestForm.get('speedMaxTolPercentage')?.setValue(true);
            // }
            if (data.hoursNeedToBeCon === 'false') {
              this.requestForm.get('hoursNeedToBeCon')?.setValue(false);
            } else {
              this.requestForm.get('hoursNeedToBeCon')?.setValue(true);
            }
            if (data.multipleSpeed === 'false') {
              this.requestForm.get('multipleSpeed')?.setValue(false);
            } else {
              this.requestForm.get('multipleSpeed')?.setValue(true);
            }
            if (data.claimable === 'No') {
              this.requestForm.get('claimable')?.setValue(false);
            } else {
              this.requestForm.get('claimable')?.setValue(true);
            }
            this.requestForm.get('cosp')?.setValidators(Validators.required);
            this.requestForm
              .get('cospHours')
              ?.setValidators(Validators.required);
            this.requestForm
              .get('cospMinutes')
              ?.setValidators(Validators.required);
            this.requestForm.get('eosp')?.setValidators(Validators.required);
            this.requestForm
              .get('eospHours')
              ?.setValidators(Validators.required);
            this.requestForm
              .get('eospMinutes')
              ?.setValidators(Validators.required);
            this.requestForm.get('client')?.setValue(data.client_name);
            this.requestForm.get('fuelTypeOne')?.setValue(data.fueltypeone);
            this.requestForm.get('fuelTypeTwo')?.setValue(data.fueltypetwo);
            this.requestForm.get('cpGasOil')?.setValue(data.cpgasoil);
            this.requestForm.get('bfLimitDss')?.setValue(data.bflimitdss);
            this.requestForm.get('currLng')?.setValue(Math.abs(data.long));
            this.requestForm.get('currLat')?.setValue(Math.abs(data.lat));
            this.requestForm.get('eigerPic')?.setValue(data.eigerpic);
            this.requestForm.get('weatherSource')?.setValue(data.weatherSource);
            let lat = data.lat;
            if (lat !== '') {
              let direction = lat < 0 ? 'S' : 'N';
              this.requestForm.get('latDir')?.setValue(direction);
            }

            let long = data.long;
            if (long !== '') {
              let lonDir = long < 0 ? 'W' : 'E';
              this.requestForm.get('longDir')?.setValue(lonDir);
            }

            this.requestForm.get('repWindBf')?.setValue(data.repWindBf);
            this.requestForm.get('repSwell')?.setValue(data.repSwell);
            this.requestForm.get('repAvgSpeed')?.setValue(data.repAvgSpeed);
            this.requestForm.get('voyAvgSpeed')?.setValue(data.voyAvgSpeed);
            this.requestForm
              .get('periodiccurrentfactor')
              ?.setValue(data.periodiccurrentfactor);
            this.requestForm.get('etaDate')?.setValue(ETAdate[0]);
            this.requestForm
              .get('etaHours')
              ?.setValue(ETAdate[1]?.split(':')[0]);
            this.requestForm
              .get('etaMinutes')
              ?.setValue(ETAdate[1]?.split(':')[1]);
            this.requestForm.get('reportedDate')?.setValue(reportedDate[0]);
            this.requestForm
              .get('reportedHours')
              ?.setValue(reportedDate[1]?.split(':')[0]);
            this.requestForm
              .get('reportedMinutes')
              ?.setValue(reportedDate[1]?.split(':')[1]);
            this.requestForm.get('cosp')?.setValue(cospDate[0]);
            this.requestForm
              .get('cospHours')
              ?.setValue(cospDate[1]?.split(':')[0]);
            this.requestForm
              .get('cospMinutes')
              ?.setValue(cospDate[1]?.split(':')[1]);
            this.requestForm.get('eosp')?.setValue(eospDate[0]);
            this.requestForm
              .get('eospHours')
              ?.setValue(eospDate[1]?.split(':')[0]);
            this.requestForm
              .get('eospMinutes')
              ?.setValue(eospDate[1]?.split(':')[1]);
            this.datesValidator = true;
            this.requestForm.get('id')?.setValue('');
            const validSegments = ['LR1', 'LR2', 'LR3', 'VLCC', 'MR'];

            let segment = (data.segment || '').toString().trim();

            // Handle special case MR2 → MR
            if (segment.toUpperCase() === 'MR2') {
              segment = 'MR';
            } else if (validSegments.includes(segment.toUpperCase())) {
              // If it's in special list, keep fully uppercase
              segment = segment.toUpperCase();
            } else {
              // Otherwise convert first letter capital, rest lower
              segment =
                segment.charAt(0).toUpperCase() +
                segment.slice(1).toLowerCase();
            }

            this.segmentOptions = this.segmentMapping[data.typeOfShip] || [];
            this.requestForm.get('segment')?.setValue(segment);
          }
        },
        error: (err) => {
          console.error('Error:', err);
          // Handle error (e.g., toast message)
        },
      });
    }
  }

  // ngOnInit() {
  //   this.loadClientOptions();
  //   this.route.queryParams.subscribe((params: any) => {
  //     this.reportType = params?.reportType || 'excel';

  //     if (this.reportType === 'json') {
  //       const dummyIMO = '9375317';
  //       const dummyVoyage = '04';

  //       this.loadFleetEventsDropdown(dummyIMO, dummyVoyage);
  //     }
  //   });

  //   this.sharedDataService.fleetViewRowData$.subscribe((data: any) => {
  //     if (!data) return;

  //     this.id = data?.id;

  //     const imo = data?.imoNumber;
  //     const voyage = data?.voyageNumber;

  //     if (this.reportType === 'json' && imo && voyage) {
  //       this.loadFleetEventsDropdown(imo, voyage);
  //     }

  //     if (data?.id) {
  //       this.reportGenerate = true;

  //       const ETAdate = data.etaDate?.split(' ') || [];
  //       const reportedDate = data.time_of_report?.split(' ') || [];

  //       this.requestForm.patchValue(data);

  //       this.requestForm
  //         .get('hoursNeedToBeCon')
  //         ?.setValue(data.hoursNeedToBeCon !== 'false');
  //       this.requestForm
  //         .get('multipleSpeed')
  //         ?.setValue(data.multipleSpeed !== 'false');
  //       this.requestForm.get('claimable')?.setValue(data.claimable !== 'No');

  //       this.requestForm.get('cosp')?.setValidators(Validators.required);
  //       this.requestForm.get('cospHours')?.setValidators(Validators.required);
  //       this.requestForm.get('cospMinutes')?.setValidators(Validators.required);

  //       this.requestForm.get('eosp')?.setValidators(Validators.required);
  //       this.requestForm.get('eospHours')?.setValidators(Validators.required);
  //       this.requestForm.get('eospMinutes')?.setValidators(Validators.required);

  //       this.requestForm.get('client')?.setValue(data.client_name);
  //       this.requestForm.get('fuelTypeOne')?.setValue(data.fueltypeone);
  //       this.requestForm.get('fuelTypeTwo')?.setValue(data.fueltypetwo);

  //       this.requestForm.get('currLng')?.setValue(Math.abs(data.long));
  //       this.requestForm.get('currLat')?.setValue(Math.abs(data.lat));
  //       this.requestForm.get('weatherSource')?.setValue(data.weatherSource);

  //       this.requestForm.get('etaDate')?.setValue(ETAdate[0]);
  //       this.requestForm.get('etaHours')?.setValue(ETAdate[1]?.split(':')[0]);
  //       this.requestForm.get('etaMinutes')?.setValue(ETAdate[1]?.split(':')[1]);

  //       this.requestForm.get('reportedDate')?.setValue(reportedDate[0]);
  //       this.requestForm
  //         .get('reportedHours')
  //         ?.setValue(reportedDate[1]?.split(':')[0]);
  //       this.requestForm
  //         .get('reportedMinutes')
  //         ?.setValue(reportedDate[1]?.split(':')[1]);

  //       this.datesValidator = true;

  //       const validSegments = ['LR1', 'LR2', 'LR3', 'VLCC', 'MR'];
  //       let segment = (data.segment || '').toString().trim();

  //       if (segment.toUpperCase() === 'MR2') segment = 'MR';
  //       else if (validSegments.includes(segment.toUpperCase()))
  //         segment = segment.toUpperCase();
  //       else
  //         segment =
  //           segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();

  //       this.segmentOptions = this.segmentMapping[data.typeOfShip] || [];
  //       this.requestForm.get('segment')?.setValue(segment);
  //     }

  //     this.requestFormService
  //       .getUploadedMainCp(data?.id, data?.client_name)
  //       .subscribe(
  //         () => (this.mainCpFile = true),
  //         () => (this.mainCpFile = false),
  //       );
  //   });

  //   this.portDetails.getPortDetails().subscribe((response: any) => {
  //     this.filteredPortNames = response?.data ?? [];
  //   });

  //   this.requestForm
  //     .get('typeOfShip')
  //     ?.valueChanges.subscribe((selectedType: any) => {
  //       this.segmentOptions = this.segmentMapping[selectedType] || [];
  //       this.requestForm.get('segment')?.reset();
  //     });

  //   this.requestForm.get('cosp')?.valueChanges.subscribe((val: any) => {
  //     if (this.reportType !== 'json') return;
  //     if (!val) return;

  //     const selectedValue = val?.value || val;

  //     const selectedEvent = this.cospEvents.find(
  //       (ev: any) =>
  //         `${ev.departurePort} - ${this.formatDate(ev.report_timestamp)}` ===
  //         selectedValue,
  //     );

  //     if (selectedEvent) {
  //       this.requestForm.patchValue({ pFrom: selectedEvent.departurePort });
  //     }
  //   });

  //   this.requestForm.get('eosp')?.valueChanges.subscribe((val: any) => {
  //     if (this.reportType !== 'json') return;
  //     if (!val) return;

  //     const selectedValue = val?.value || val;

  //     const selectedEvent = this.eospEvents.find(
  //       (ev: any) =>
  //         `${ev.destinationPort} - ${this.formatDate(ev.report_timestamp)}` ===
  //         selectedValue,
  //     );

  //     if (selectedEvent) {
  //       this.requestForm.patchValue({ pTo: selectedEvent.destinationPort });
  //     }
  //   });
  // }
  loadClientOptions() {
    this.requestFormService.getClientList().subscribe({
      next: (res: any[]) => {
        this.clientOptions = res.map((client) => client.client_name);
      },
      error: (err) => console.error('Client API error', err),
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      this.fileType = params?.reportType || 'excel';
      if (params['type'] === 'default') {
        this.isForm = false;
      } else if (params['type'] === 'initial') {
        this.isForm = true;
      }
    });
    this.loadClientOptions();

    this.sharedDataService.fleetViewRowData$.subscribe((data) => {
      this.id = data?.id;
      if (data?.id) {
        const imo = data?.imoNumber;
        const voyage = encodeURIComponent(data?.voyNumber);
        if (this.fileType === 'json') {
          this.loadFleetEventsDropdown(imo, voyage);
        }
        this.reportGenerate = true;

        const cospDate = data.cosp.split(' ') || [];
        const eospDate = data.eosp.split(' ') || [];
        const ETAdate = data.etaDate.split(' ') || [];
        const reportedDate = data.time_of_report?.split(' ') || [];
        this.requestForm.patchValue(data);
        const newFormulaVal = data?.useNewCurrentFormula || data?.usenewcurrentformula;
        if (newFormulaVal) {
          this.requestForm.get('useNewCurrentFormula')?.setValue(newFormulaVal);
        }
        // if (data.speedMinTolPercentage === 'false') {
        //   this.requestForm.get('speedMinTolPercentage')?.setValue(false);
        // } else {
        //   this.requestForm.get('speedMinTolPercentage')?.setValue(true);
        // }
        // if (data.speedMaxTolPercentage === 'false') {
        //   this.requestForm.get('speedMaxTolPercentage')?.setValue(false);
        // } else {
        //   this.requestForm.get('speedMaxTolPercentage')?.setValue(true);
        // }
        if (data.hoursNeedToBeCon === 'false') {
          this.requestForm.get('hoursNeedToBeCon')?.setValue(false);
        } else {
          this.requestForm.get('hoursNeedToBeCon')?.setValue(true);
        }
        if (data.multipleSpeed === 'false') {
          this.requestForm.get('multipleSpeed')?.setValue(false);
        } else {
          this.requestForm.get('multipleSpeed')?.setValue(true);
        }
        if (data.claimable === 'No') {
          this.requestForm.get('claimable')?.setValue(false);
        } else {
          this.requestForm.get('claimable')?.setValue(true);
        }
        this.requestForm.get('cosp')?.setValidators(Validators.required);
        this.requestForm.get('cospHours')?.setValidators(Validators.required);
        this.requestForm.get('cospMinutes')?.setValidators(Validators.required);
        this.requestForm.get('eosp')?.setValidators(Validators.required);
        this.requestForm.get('eospHours')?.setValidators(Validators.required);
        this.requestForm.get('eospMinutes')?.setValidators(Validators.required);
        this.requestForm.get('client')?.setValue(data.client_name);
        this.requestForm.get('fuelTypeOne')?.setValue(data.fueltypeone);
        this.requestForm.get('fuelTypeTwo')?.setValue(data.fueltypetwo);
        this.requestForm.get('cpGasOil')?.setValue(data.cpgasoil);
        this.requestForm.get('bfLimitDss')?.setValue(data.bflimitdss);
        this.requestForm.get('currLng')?.setValue(Math.abs(data.long));
        this.requestForm.get('currLat')?.setValue(Math.abs(data.lat));
        this.requestForm.get('eigerPic')?.setValue(data.eigerpic);
        this.requestForm.get('weatherSource')?.setValue(data.weatherSource);
        if (data.zn_format) {
          this.requestForm.get('zn_format')?.setValue(data.zn_format);
        } else if (data.client_name === 'ZeroNorth' || data.client === 'ZeroNorth') {
          this.requestForm.get('zn_format')?.setValue('new');
        }
        let lat = data.lat;
        if (lat !== '') {
          let direction = lat < 0 ? 'S' : 'N';
          this.requestForm.get('latDir')?.setValue(direction);
        }

        let long = data.long;
        if (long !== '') {
          let lonDir = long < 0 ? 'W' : 'E';
          this.requestForm.get('longDir')?.setValue(lonDir);
        }

        this.requestForm.get('repWindBf')?.setValue(data.repWindBf);
        this.requestForm.get('repSwell')?.setValue(data.repSwell);
        this.requestForm.get('repAvgSpeed')?.setValue(data.repAvgSpeed);
        this.requestForm.get('voyAvgSpeed')?.setValue(data.voyAvgSpeed);
        this.requestForm
          .get('periodiccurrentfactor')
          ?.setValue(data.periodiccurrentfactor);
        this.requestForm.get('etaDate')?.setValue(ETAdate[0]);
        this.requestForm.get('etaHours')?.setValue(ETAdate[1]?.split(':')[0]);
        this.requestForm.get('etaMinutes')?.setValue(ETAdate[1]?.split(':')[1]);
        this.requestForm.get('reportedDate')?.setValue(reportedDate[0]);
        this.requestForm
          .get('reportedHours')
          ?.setValue(reportedDate[1]?.split(':')[0]);
        this.requestForm
          .get('reportedMinutes')
          ?.setValue(reportedDate[1]?.split(':')[1]);
        this.requestForm.get('cosp')?.setValue(cospDate[0]);
        this.requestForm.get('cospHours')?.setValue(cospDate[1]?.split(':')[0]);
        this.requestForm
          .get('cospMinutes')
          ?.setValue(cospDate[1]?.split(':')[1]);
        this.requestForm.get('eosp')?.setValue(eospDate[0]);
        this.requestForm.get('eospHours')?.setValue(eospDate[1]?.split(':')[0]);
        this.requestForm
          .get('eospMinutes')
          ?.setValue(eospDate[1]?.split(':')[1]);
        this.datesValidator = true;
        // Special segments to always keep uppercase
        const validSegments = ['LR1', 'LR2', 'LR3', 'VLCC', 'MR'];

        let segment = (data.segment || '').toString().trim();

        // Handle special case MR2 → MR
        if (segment.toUpperCase() === 'MR2') {
          segment = 'MR';
        } else if (validSegments.includes(segment.toUpperCase())) {
          // If it's in special list, keep fully uppercase
          segment = segment.toUpperCase();
        } else {
          // Otherwise convert first letter capital, rest lower
          segment =
            segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
        }

        this.segmentOptions = this.segmentMapping[data.typeOfShip] || [];
        this.requestForm.get('segment')?.setValue(segment);
      }
      this.requestFormService
        .getUploadedMainCp(data?.id, data?.client_name)
        .subscribe(
          (fileData: Blob) => {
            this.mainCpFile = true;
          },
          (error) => {
            this.mainCpFile = false;
          },
        );
    });
    this.portDetails.getPortDetails().subscribe((response: any) => {
      this.filteredPortNames = response?.data ?? [];
    });

    // this.requestForm.get('mainCp')?.valueChanges.subscribe(value => {
    //   const wordCount: number = value.trim().split(/\s+/).length;

    //   if (wordCount > 3) {
    //     // Truncate the value to the first three words
    //     const truncatedValue: string = value.trim().split(/\s+/).slice(0, 3).join(' ');
    //     this.requestForm.get('mainCp')?.setValue(truncatedValue, { emitEvent: false });

    //   }
    // });
    this.requestForm
      .get('typeOfShip')
      ?.valueChanges.subscribe((selectedType) => {
        this.segmentOptions = this.segmentMapping[selectedType] || [];
        this.requestForm.get('segment')?.reset();
      });

    this.requestForm.get('cosp')?.valueChanges.subscribe((val: any) => {
      if (this.fileType !== 'json') return;
      if (!val) return;

      const selectedValue = val?.value || val;

      const selectedEvent = this.cospEvents.find(
        (ev: any) =>
          `${ev.departurePort} - ${ev.report_timestamp}` === selectedValue,
      );

      if (selectedEvent) {
        this.requestForm.patchValue({ pFrom: selectedEvent.departurePort });
      }
    });

    this.requestForm.get('eosp')?.valueChanges.subscribe((val: any) => {
      if (this.fileType !== 'json') return;
      if (!val) return;

      const selectedValue = val?.value || val;

      const selectedEvent = this.eospEvents.find(
        (ev: any) =>
          `${ev.destinationPort} - ${ev.report_timestamp}` === selectedValue,
      );

      if (selectedEvent) {
        this.requestForm.patchValue({ pTo: selectedEvent.destinationPort });
      }
    });

    this.requestForm.get('reportType')?.valueChanges.subscribe((type) => {
      if (type === 'json') {
        this.fileType = 'json';

        // 🔥 CLEAR COSP & EOSP
        this.requestForm.patchValue(
          {
            cosp: null,
            cospHours: null,
            cospMinutes: null,
            eosp: null,
            eospHours: null,
            eospMinutes: null,
          },
          { emitEvent: false },
        );
      }
    });
  }
  loadFleetEventsDropdown(imo: any, voyage: any) {
    this.prequestFormService.getFleetEvents(imo, voyage).subscribe({
      next: (res: any) => {
        const apiData = res?.data || {};

        this.cospEvents = apiData.cosp_events || [];
        this.eospEvents = apiData.eosp_events || [];

        this.cospDropdownList = this.cospEvents.map(
          (ev: any) => `${ev.departurePort} - ${ev.report_timestamp}`,
        );

        this.eospDropdownList = this.eospEvents.map(
          (ev: any) => `${ev.destinationPort} - ${ev.report_timestamp}`,
        );

        this.requestForm.patchValue({
          cosp: '',
          eosp: '',
        });
      },
      error: (err: any) => console.log(' API Error:', err),
    });
  }

  onCospChange(event: any) {
    const selectedValue = event?.value || event?.target?.value || event;
    if (!selectedValue) return;

    const selectedEvent = this.cospEvents.find(
      (ev: any) =>
        `${ev.departurePort} - ${this.formatDate(ev.report_timestamp)}` ===
        selectedValue,
    );

    if (!selectedEvent) return;

    this.requestForm.patchValue({
      pFrom: selectedEvent.departurePort,
    });
  }

  onEospChange(event: any) {
    const selectedValue = event?.value || event?.target?.value || event;
    if (!selectedValue) return;

    const selectedEvent = this.eospEvents.find(
      (ev: any) =>
        `${ev.destinationPort} - ${this.formatDate(ev.report_timestamp)}` ===
        selectedValue,
    );

    if (!selectedEvent) return;

    this.requestForm.patchValue({
      pTo: selectedEvent.destinationPort,
    });
  }

  formatDate(timestamp: string): string {
    const d = new Date(timestamp);
    return d.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }

  getDateTimeParts(timestamp: string) {
    const d = new Date(timestamp);

    const date = d.toISOString().split('T')[0]; // yyyy-mm-dd
    const hours = String(d.getUTCHours()).padStart(2, '0');
    const minutes = String(d.getUTCMinutes()).padStart(2, '0');

    return { date, hours, minutes };
  }

  setSegmentValue(type: string, dataSegment: string) {
    const segments = this.segmentMapping[type] || [];

    // Normalize input
    const normalized = dataSegment?.toLowerCase();

    // Try to find match ignoring case
    const matched = segments.find(
      (seg) =>
        seg.value.toLowerCase() === normalized ||
        seg.label.toLowerCase() === normalized,
    );

    if (matched) {
      this.requestForm.get('segment')?.setValue(matched.value);
    } else {
      // fallback: set raw value if no match
      this.requestForm.get('segment')?.setValue(dataSegment);
    }
  }

  onShipTypeChange(event: any) {
    const selectedType = event.target.value;
    this.segmentOptions = this.segmentMapping[selectedType] || [];
    // this.requestForm.get('segment')?.reset();
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  onInputChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 30) {
      inputElement.value = currentValue.slice(0, 30);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onVoyageChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 10) {
      inputElement.value = currentValue.slice(0, 10);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    const maxLength = 4;
    if (numericValue.length > maxLength) {
      inputElement.value = numericValue.slice(0, maxLength);
    } else {
      inputElement.value = numericValue;
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  numberInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    inputElement.value = numericValue;
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  clearClick() {
    this.requestForm.get('cosp')?.clearValidators();
    this.requestForm.get('cospHours')?.clearValidators();
    this.requestForm.get('cospMinutes')?.clearValidators();
    this.requestForm.get('eosp')?.clearValidators();
    this.requestForm.get('eospHours')?.clearValidators();
    this.requestForm.get('eospMinutes')?.clearValidators();
    this.requestForm.reset();
    this.formSubmitted = false;
    this.reportGenerate = false;
    this.mainCpFile = false;
    this.datesValidator = false;
  }
  uploadfile() {
    // open popup of excel file or json file
    if (this.fileInput) {
      (this.fileInput.nativeElement as HTMLInputElement).click();
    }
  }
  uploadMainCp() {
    if (this.fileUpload) {
      (this.fileUpload.nativeElement as HTMLInputElement).click();
    }
  }
  onFileSelectedimage(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      // console.log("File",file)
      //console.log("FinalFormValue",this.requestForm.value)
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (
        extension === 'png' ||
        extension === 'jpg' ||
        extension === 'jpeg' ||
        extension === 'pdf'
      ) {
        this.selectedMainCPFile = file;
        // console.log("this.selectedMainCPFile",this.selectedMainCPFile)
        this.toastr.success(ToasterMessages.FileUpload);
      } else {
        this.toastr.warning(ToasterMessages.FileWarning);
      }
    }
  }

  reportClick() {
    if (this.requestForm.valid) {
      if (
        this.fileType === 'json' ||
        (this.fileType === 'excel' && this.selectedFile)
      ) {
        if (this.requestForm.get('id')?.value) {
          const etaDate = this.requestForm.get('etaDate')?.value;
          const etaHours = this.requestForm.get('etaHours')?.value || '00';
          const etaMinutes = this.requestForm.get('etaMinutes')?.value || '00';
          const combinedEtaDateTime =
            etaDate +
            (etaHours && etaMinutes ? ' ' + etaHours + ':' + etaMinutes : '');
          const cospDate = this.requestForm.get('cosp')?.value;
          const cospHours = this.requestForm.get('cospHours')?.value || '00';
          const cospMinutes =
            this.requestForm.get('cospMinutes')?.value || '00';
          let combinedCospDateTime =
            cospDate +
            (cospHours && cospMinutes
              ? ' ' + cospHours + ':' + cospMinutes
              : '');
          const eospDate = this.requestForm.get('eosp')?.value;
          const eospHours = this.requestForm.get('eospHours')?.value || '00';
          const eospMinutes =
            this.requestForm.get('eospMinutes')?.value || '00';
          let combinedEospDateTime =
            eospDate +
            (eospHours && eospMinutes
              ? ' ' + eospHours + ':' + eospMinutes
              : '');
          if (this.fileType === 'json') {
            const rawCosp = this.requestForm.get('cosp')?.value;
            const rawEosp = this.requestForm.get('eosp')?.value;
            combinedCospDateTime =
              this.convertDropdownToDateTime(rawCosp) || '';
            combinedEospDateTime =
              this.convertDropdownToDateTime(rawEosp) || '';
          }
          const jsonData = {
            ship: this.requestForm.get('ship')?.value,
            imoNumber: this.requestForm.get('imoNumber')?.value || '',
            voyNumber: this.requestForm.get('voyNumber')?.value || '',
            segment: this.requestForm.get('segment')?.value || '',
            typeOfShip: this.requestForm.get('typeOfShip')?.value || '',
            merakiPic: this.requestForm.get('merakiPic')?.value,
            shipYard: this.requestForm.get('shipYard')?.value || '',
            yearBuilt: this.requestForm.get('yearBuilt')?.value,
            pFrom: this.requestForm.get('pFrom')?.value || '',
            pTo: this.requestForm.get('pTo')?.value || '',
            etaDate: combinedEtaDateTime || '',
            cosp: combinedCospDateTime || '',
            eosp: combinedEospDateTime || '',
            client: this.requestForm.get('client')?.value || '',
            templet: this.requestForm.get('templet')?.value || '',
            zn_format: this.requestForm.get('zn_format')?.value || '',
            typeSpeed: this.requestForm.get('typeSpeed')?.value || '',
            fuelTypeOne: this.requestForm.get('fuelTypeOne')?.value || '',
            fuelTypeTwo: this.requestForm.get('fuelTypeTwo')?.value || '',
            voyageType: this.requestForm.get('voyageType')?.value || '',
            reportType: this.requestForm.get('reportType')?.value || '',
            fuelMethod: this.requestForm.get('fuelMethod')?.value || '',
            allDayPositive: this.requestForm.get('allDayPositive')?.value || '',
            cpOrderedSpeed:
              this.requestForm.get('cpOrderedSpeed')?.value?.toString() || '',
            multipleSpeed:
              this.requestForm.get('multipleSpeed')?.value?.toString() || '',
            claimable: this.requestForm.get('claimable')?.value ? 'Yes' : 'No',
            fuelType: this.requestForm.get('fuelType')?.value || '',
            cpFuel: this.requestForm.get('cpFuel')?.value || '',
            cpFuelOne: this.requestForm.get('cpFuelOne')?.value || '',
            cpOthers: this.requestForm.get('cpOthers')?.value || '',
            aboutSc: this.requestForm.get('aboutSc')?.value || '',
            windBeaufort:
              this.requestForm.get('windBeaufort')?.value?.toString() || '',
            windWave: this.requestForm.get('windWave')?.value?.toString() || '',
            swellHeight:
              this.requestForm.get('swellHeight')?.value?.toString() || '',
            significantWave:
              this.requestForm.get('significantWave')?.value?.toString() || '',
            adverseCurrent: this.requestForm.get('adverseCurrent')?.value || '',
            currentFactor: this.requestForm.get('currentFactor')?.value || '',
            weatherFactor: this.requestForm.get('weatherFactor')?.value || '',
            currentOnlyNeg: this.requestForm.get('currentOnlyNeg')?.value || '',
            adverseSwellEx: this.requestForm.get('adverseSwellEx')?.value || '',
            hoursNeedToBeCon:
              this.requestForm.get('hoursNeedToBeCon')?.value?.toString() || '',
            goodWeatherPeriod:
              this.requestForm.get('goodWeatherPeriod')?.value?.toString() ||
              '',
            performanceCal: this.requestForm.get('performanceCal')?.value || '',
            excludeFirst:
              this.requestForm.get('excludeFirst')?.value?.toString() || '',
            excludeLast:
              this.requestForm.get('excludeLast')?.value?.toString() || '',
            speedMinTol:
              this.requestForm.get('speedMinTol')?.value?.toString() || '',
            speedMaxTol:
              this.requestForm.get('speedMaxTol')?.value?.toString() || '',
            speedMinTolPercentage:
              this.requestForm
                .get('speedMinTolPercentage')
                ?.value?.toString() || '',
            speedMaxTolPercentage:
              this.requestForm
                .get('speedMaxTolPercentage')
                ?.value?.toString() || '',
            consMinTol:
              this.requestForm.get('consMinTol')?.value?.toString() || '',
            consMaxTol:
              this.requestForm.get('consMaxTol')?.value?.toString() || '',
            extrapolationMethod:
              this.requestForm.get('extrapolationMethod')?.value || '',
            wetherCalculation:
              this.requestForm.get('wetherCalculation')?.value || '',
            secaEca: this.requestForm.get('secaEca')?.value || '',
            duelFuel: this.requestForm.get('duelFuel')?.value || '',
            cpGasOil: this.requestForm.get('cpGasOil')?.value || '',
            bfLimitDss: this.requestForm.get('bfLimitDss')?.value || '',
            mainCp: this.requestForm.get('mainCp')?.value || '',
            additionalComments:
              this.requestForm.get('additionalComments')?.value || '',
            id: this.requestForm.get('id')?.value || '',
            status: this.requestForm.get('status')?.value || '',
            periodiccurrentfactor:
              this.requestForm.get('periodiccurrentfactor')?.value || '',
            eigerPic: this.requestForm.get('eigerPic')?.value,
            weatherSource: this.requestForm.get('weatherSource')?.value,
            uniqueVoyId: this.requestForm.get('uniqueVoyId')?.value,
            useNewCurrentFormula:
              this.requestForm.get('useNewCurrentFormula')?.value || 'NO',
            usenewcurrentformula:
              this.requestForm.get('useNewCurrentFormula')?.value || 'NO',
            has_mid_voyage: this.requestForm.get('has_mid_voyage')?.value || false,
            lock_until_date: this.requestForm.get('lock_until_date')?.value || '',
            ship_length: this.requestForm.get('ship_length')?.value,
            ship_breadth: this.requestForm.get('ship_breadth')?.value,
            windage_area: this.requestForm.get('windage_area')?.value,
            power: this.requestForm.get('power')?.value,
            wind_drag_coef: this.requestForm.get('wind_drag_coef')?.value,
            air_density: this.requestForm.get('air_density')?.value,
            empirical_constant:
              this.requestForm.get('empirical_constant')?.value,
          };
          const json_string = this.dataToPass.formData;
          const files = this.dataToPass.files;
          const rawCosp = this.requestForm.get('cosp')?.value;
          const rawEosp = this.requestForm.get('eosp')?.value;
          let payload = {
            imo_number: this.requestForm.get('imoNumber')?.value || '',
            start_date: this.convertDropdownToDateTime(rawCosp) || '',
            end_date: this.convertDropdownToDateTime(rawEosp) || '',
          };

          if (this.fileType === 'json') {
            this.requestFormService
              .postRequestForm(jsonData, json_string, payload)
              .subscribe(
                (data) => {
                  this.toastr.success(ToasterMessages.ReportGenaration);
                  this.clearClick();
                },
                (error) => {
                  if (error.error.text === 'Responding: Process Triggered...') {
                    this.toastr.success(ToasterMessages.ReportGenaration);
                    this.clearClick();
                  } else {
                    this.toastr.error(error.error.text);
                  }
                },
              );
          } else {
            this.requestFormService
              .postRequestForm(jsonData, json_string, files)
              .subscribe(
                (data) => {
                  this.toastr.success(ToasterMessages.ReportGenaration);
                  this.clearClick();
                },
                (error) => {
                  if (error.error.text === 'Responding: Process Triggered...') {
                    this.toastr.success(ToasterMessages.ReportGenaration);
                    this.clearClick();
                  } else {
                    this.toastr.error(error.error.text);
                  }
                },
              );
          }
        } else {
          this.toastr.warning(ToasterMessages.SubmitValidation);
        }
      } else {
        this.toastr.warning(ToasterMessages.FileValidation);
      }
    } else {
      this.formSubmitted = true;
      this.toastr.info(ToasterMessages.FormValidation);
    }
  }
  submitClick() {
    const reportedDate = this.requestForm.get('reportedDate')?.value;
    const reportedHours = this.requestForm.get('reportedHours')?.value || '00';
    const reportedMinutes =
      this.requestForm.get('reportedMinutes')?.value || '00';
    const combinedreportedDateTime =
      reportedDate +
      (reportedHours && reportedMinutes
        ? ' ' + reportedHours + ':' + reportedMinutes
        : '');
    const etaDate = this.requestForm.get('etaDate')?.value;
    const etaHours = this.requestForm.get('etaHours')?.value || '00';
    const etaMinutes = this.requestForm.get('etaMinutes')?.value || '00';
    const combinedEtaDateTime =
      etaDate +
      (etaHours && etaMinutes ? ' ' + etaHours + ':' + etaMinutes : '');
    const cospDate = this.requestForm.get('cosp')?.value;
    const cospHours = this.requestForm.get('cospHours')?.value || '00';
    const cospMinutes = this.requestForm.get('cospMinutes')?.value || '00';
    let combinedCospDateTime =
      cospDate +
      (cospHours && cospMinutes ? ' ' + cospHours + ':' + cospMinutes : '');
    const eospDate = this.requestForm.get('eosp')?.value;
    const eospHours = this.requestForm.get('eospHours')?.value || '00';
    const eospMinutes = this.requestForm.get('eospMinutes')?.value || '00';
    let combinedEospDateTime =
      eospDate +
      (eospHours && eospMinutes ? ' ' + eospHours + ':' + eospMinutes : '');
    let latDirection = this.requestForm.get('latDir')?.value;
    let latitudeValue = this.requestForm.get('currLat')?.value;
    if (latDirection === 'S') {
      latitudeValue = '-' + latitudeValue;
    }
    const latitude = latitudeValue;
    let longDirection = this.requestForm.get('longDir')?.value;
    let longitudeValue = this.requestForm.get('currLng')?.value;
    if (longDirection === 'W') {
      longitudeValue = '-' + longitudeValue;
    }
    const longitude = longitudeValue;
    if (this.fileType === 'json') {
      const rawCosp = this.requestForm.get('cosp')?.value;
      const rawEosp = this.requestForm.get('eosp')?.value;
      combinedCospDateTime = this.convertDropdownToDateTime(rawCosp) || '';
      combinedEospDateTime = this.convertDropdownToDateTime(rawEosp) || '';
    }
    let payload = {
      ship: this.requestForm.get('ship')?.value,
      imoNumber: this.requestForm.get('imoNumber')?.value || '',
      voyNumber: this.requestForm.get('voyNumber')?.value || '',
      segment: this.requestForm.get('segment')?.value || '',
      typeOfShip: this.requestForm.get('typeOfShip')?.value || '',
      merakiPic: this.requestForm.get('merakiPic')?.value,
      eigerPic: this.requestForm.get('eigerPic')?.value,
      shipYard: this.requestForm.get('shipYard')?.value || '',
      yearBuilt: this.requestForm.get('yearBuilt')?.value,
      pFrom: this.requestForm.get('pFrom')?.value || '',
      pTo: this.requestForm.get('pTo')?.value || '',
      etaDate: combinedEtaDateTime || '',
      cosp: combinedCospDateTime || '',
      eosp: combinedEospDateTime || '',
      client: this.requestForm.get('client')?.value || '',
      templet: this.requestForm.get('templet')?.value || '',
      zn_format: this.requestForm.get('zn_format')?.value || '',
      typeSpeed: this.requestForm.get('typeSpeed')?.value || '',
      fuelTypeOne: this.requestForm.get('fuelTypeOne')?.value || '',
      fuelTypeTwo: this.requestForm.get('fuelTypeTwo')?.value || '',
      voyageType: this.requestForm.get('voyageType')?.value || '',
      reportType: this.requestForm.get('reportType')?.value || '',
      fuelMethod: this.requestForm.get('fuelMethod')?.value || '',
      allDayPositive: this.requestForm.get('allDayPositive')?.value || '',
      cpOrderedSpeed:
        this.requestForm.get('cpOrderedSpeed')?.value?.toString() || '',
      multipleSpeed:
        this.requestForm.get('multipleSpeed')?.value?.toString() || '',
      claimable: this.requestForm.get('claimable')?.value ? 'Yes' : 'No',
      fuelType: this.requestForm.get('fuelType')?.value || '',
      cpFuel: this.requestForm.get('cpFuel')?.value || '',
      cpFuelOne: this.requestForm.get('cpFuelOne')?.value || '',
      cpOthers: this.requestForm.get('cpOthers')?.value || '',
      aboutSc: this.requestForm.get('aboutSc')?.value || '',
      windBeaufort:
        this.requestForm.get('windBeaufort')?.value?.toString() || '',
      windWave: this.requestForm.get('windWave')?.value?.toString() || '',
      swellHeight: this.requestForm.get('swellHeight')?.value?.toString() || '',
      significantWave:
        this.requestForm.get('significantWave')?.value?.toString() || '',
      adverseCurrent: this.requestForm.get('adverseCurrent')?.value || '',
      currentFactor: this.requestForm.get('currentFactor')?.value || '',
      weatherFactor: this.requestForm.get('weatherFactor')?.value || '',
      useNewCurrentFormula: this.requestForm.get('useNewCurrentFormula')?.value || this.requestForm.get('usenewcurrentformula')?.value || 'NO',
      usenewcurrentformula: this.requestForm.get('useNewCurrentFormula')?.value || this.requestForm.get('usenewcurrentformula')?.value || 'NO',
      has_mid_voyage: this.requestForm.get('has_mid_voyage')?.value || false,
      lock_until_date: this.requestForm.get('lock_until_date')?.value || '',
      periodiccurrentfactor:
        this.requestForm.get('periodiccurrentfactor')?.value || '',
      currentOnlyNeg: this.requestForm.get('currentOnlyNeg')?.value || '',
      adverseSwellEx: this.requestForm.get('adverseSwellEx')?.value || '',
      hoursNeedToBeCon:
        this.requestForm.get('hoursNeedToBeCon')?.value?.toString() || '',
      goodWeatherPeriod:
        this.requestForm.get('goodWeatherPeriod')?.value?.toString() || '',
      performanceCal: this.requestForm.get('performanceCal')?.value || '',
      excludeFirst:
        this.requestForm.get('excludeFirst')?.value?.toString() || '',
      excludeLast: this.requestForm.get('excludeLast')?.value?.toString() || '',
      speedMinTol: this.requestForm.get('speedMinTol')?.value?.toString() || '',
      speedMaxTol: this.requestForm.get('speedMaxTol')?.value?.toString() || '',
      speedMinTolPercentage:
        this.requestForm.get('speedMinTolPercentage')?.value?.toString() || '',
      speedMaxTolPercentage:
        this.requestForm.get('speedMaxTolPercentage')?.value?.toString() || '',
      consMinTol: this.requestForm.get('consMinTol')?.value?.toString() || '',
      consMaxTol: this.requestForm.get('consMaxTol')?.value?.toString() || '',
      extrapolationMethod:
        this.requestForm.get('extrapolationMethod')?.value || '',
      wetherCalculation: this.requestForm.get('wetherCalculation')?.value || '',
      secaEca: this.requestForm.get('secaEca')?.value || '',
      duelFuel: this.requestForm.get('duelFuel')?.value || '',
      cpGasOil: this.requestForm.get('cpGasOil')?.value || '',
      bfLimitDss: this.requestForm.get('bfLimitDss')?.value || '',
      mainCp: this.requestForm.get('mainCp')?.value || '',
      additionalComments:
        this.requestForm.get('additionalComments')?.value || '',
      id: this.requestForm.get('id')?.value || '',
      status: this.requestForm.get('status')?.value || '',
      lat: latitude || '',
      long: longitude || '',
      reportedDate: combinedreportedDateTime || '',
      repWindBf: this.requestForm.get('repWindBf')?.value || '',
      repSwell: this.requestForm.get('repSwell')?.value || '',
      repAvgSpeed: this.requestForm.get('repAvgSpeed')?.value || '',
      voyAvgSpeed: this.requestForm.get('voyAvgSpeed')?.value || '',
      filename: '',
      weatherSource: this.requestForm.get('weatherSource')?.value,
      uniqueVoyId: this.requestForm.get('uniqueVoyId')?.value,
      ship_length: this.requestForm.get('ship_length')?.value,
      ship_breadth: this.requestForm.get('ship_breadth')?.value,
      windage_area: this.requestForm.get('windage_area')?.value,
      power: this.requestForm.get('power')?.value,
      wind_drag_coef: this.requestForm.get('wind_drag_coef')?.value,
      air_density: this.requestForm.get('air_density')?.value,
      empirical_constant: this.requestForm.get('empirical_constant')?.value,
    };
    console.log(this.requestForm.value);

    if (this.requestForm.valid) {
      this.requestFormService
        .postFormDetails(payload, this.selectedMainCPFile)
        .subscribe(
          (data) => { },
          (error) => {
            if (error.error.text === 'save_button_success') {
              this.toastr.success(ToasterMessages.SubmitForm);
              this.clearClick();
            } else {
              this.toastr.error(ToasterMessages.Error);
            }
          },
        );
    } else {
      this.formSubmitted = true;

      // Find the first required field that is invalid
      const firstInvalidControl = Object.keys(this.requestForm.controls).find(
        (key) => {
          const control = this.requestForm.get(key);
          return (
            control &&
            control.invalid &&
            control.errors?.['required'] &&
            this.fieldLabels[key] // only check fields listed in fieldLabels
          );
        },
      );

      // If found, show corresponding error message
      if (firstInvalidControl) {
        const label = this.fieldLabels[firstInvalidControl];
        this.toastr.error(`${label} is required`);

        // Scroll and focus the first invalid field
        const el = document.querySelector(
          `[formControlName="${firstInvalidControl}"]`,
        );
        if (el) {
          // (el as HTMLElement).scrollIntoView({ behavior: 'smooth' });
          (el as HTMLElement).focus();
        }
      } else {
        this.toastr.info(ToasterMessages.FormValidation);
      }
    }
  }
  fieldLabels: { [key: string]: string } = {
    merakiPic: 'Meraki Pic',
    ship: 'Ship',
    imoNumber: 'IMO Number',
    typeOfShip: 'Type Of Ship',
    segment: 'Segment',
    pFrom: 'Port From',
    pTo: 'Port To',
    client: 'Client',
    weatherSource: 'Weather Source',
    typeSpeed: 'Type Speed',
    voyageType: 'Voyage Type',
    reportType: 'Report Type',
    fuelMethod: 'Fuel Method',
    cpOrderedSpeed: 'CP Ordered Speed',
    fuelType: 'Fuel Type',
    fuelTypeOne: 'Fuel Type One',
    fuelTypeTwo: 'Fuel Type Two',
    aboutSc: 'About SC',
    windBeaufort: 'Wind Beaufort',
    windWave: 'Wind Wave',
    swellHeight: 'Swell Height',
    significantWave: 'Significant Wave',
    adverseCurrent: 'Adverse Current',
    currentFactor: 'Current Factor',
    periodiccurrentfactor: 'Periodic Current Factor',
    goodWeatherPeriod: 'Good Weather Period',
    performanceCal: 'Performance Calculation',
    speedMinTol: 'Speed Min Tolerance',
    speedMaxTol: 'Speed Max Tolerance',
    consMinTol: 'Consumption Min Tolerance',
    consMaxTol: 'Consumption Max Tolerance',
    extrapolationMethod: 'Extrapolation Method',
    wetherCalculation: 'Weather Calculation',
    duelFuel: 'Dual Fuel',
    bfLimitDss: 'BF Limit DSS',
    reportedDate: 'Reported Date',
  };

  topClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  onFileSelected(event: any) {
    console.log(sessionStorage);
    console.log(localStorage);
    const file: File = event.target.files[0];
    console.log(file.size / 1024 / 1024, 'MB');
    if (file) {
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (
        extension === 'xls' ||
        extension === 'xlsx' ||
        extension === 'xlsm' ||
        extension === 'csv'
      ) {
        this.selectedFile = file;
        this.toastr.success(ToasterMessages.FileUpload);
        const dialogRef = this.dialog.open(FormPopupComponent, {
          width: '1087px',
          height: '500px',
          disableClose: true,
          data: {
            file: file,
            imo_number: this.requestForm.get('imoNumber')?.value || '',
            start_date: this.getRouteDate('cosp'),
            end_date: this.getRouteDate('eosp'),
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.dataToPass = result;
            console.log(this.dataToPass, 'result...........');
          }
        });
      } else {
        this.toastr.warning(ToasterMessages.FileWarning);
      }
    }
  }
  retriveClick() {
    this.router.navigate(['/vp-retriveForm']);
  }
  export() {
    if (this.id) {
      const formData = this.requestForm.value;
      const columnMapping: { [key: string]: string } = {
        ship: 'Ship Name',
        voyNumber: 'Voyage Number',
        segment: 'Segment',
        merakipic: 'Meraki PIC',
        pFrom: 'Port From',
        pTo: 'Port To',
        cosp: 'COSP',
        eosp: 'EOSP',
        client: 'Client',
        typeSpeed: 'Type of Speed',
        voyageType: 'Voyage Type',
        reportType: 'Report Type',
        fuelMethod: 'Fuel Method',
        cpOrderedSpeed: 'CP Ordered Speed',
        multipleSpeed: 'Multiple Speed',
        cpFuel: 'CP Fuel',
        cpFuelOne: 'CP Fuel One',
        cpOthers: 'CP Others',
        aboutSc: 'About SC',
        windBeaufort: 'Wind Beaufort',
        windWave: 'Wind Wave',
        swellHeight: 'Swell Height',
        significantWave: 'Significant Wave',
        adverseCurrent: 'Adverse Current',
        currentFactor: 'Current Factor',
        currentOnlyNeg: 'Current Only Negative',
        adverseSwellEx: 'Adverse Swell Exception',
        hoursNeedToBeCon: 'Hours Needed to be Cons',
        goodWeatherPeriod: 'Good Weather Period',
        performanceCal: 'Performance Calculation',
        excludeFirst: 'Exclude First',
        excludeLast: 'Exclude Last',
        speedMinTol: 'Speed Min Tolerance',
        speedMaxTol: 'Speed Max Tolerance',
        consMinTol: 'Cons Min Tolerance',
        consMaxTol: 'Cons Max Tolerance',
        extrapolationMethod: 'Extrapolation Method',
        wetherCalculation: 'Weather Calculation',
        secaEca: 'SECA or ECA',
        duelFuel: 'Duel Fuel',
        mainCp: 'Main CP',
        additionalComments: 'Additional Comments',
      };

      const headers = Object.keys(columnMapping);
      let csvData =
        headers.map((header) => columnMapping[header]).join(',') + '\n';
      const csvRows = headers.map((header) => formData[header]).join(',');
      csvData += csvRows + '\n';
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'requestForm.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  }
  restrictInput(inputField: any, maxAllowed: any) {
    inputField.value = inputField.value.replace(/^0+/, '');
    if (parseInt(inputField.value) > maxAllowed) {
      inputField.value = maxAllowed;
    }
    if (inputField.value === '0' || inputField.value === '') {
      inputField.value = '00';
    }
    if (inputField.value.length === 1) {
      inputField.value = '0' + inputField.value;
    }
  }

  filterPortNames(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();

    if (this.filteredPortNames && event) {
      this.portNameSuggestions = this.filteredPortNames.filter(
        (suggestion: any) =>
          suggestion.port_name.toLowerCase().startsWith(filterValue),
      );
      if (this.portNameSuggestions.length === 0) {
        this.portNameSuggestions = [];
      }
    } else {
      this.portNameSuggestions = [];
    }
  }
  maxWordsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value || '';
      const words: string[] = value.trim().split(/\s+/);
      if (words.length > 1500) {
        return { maxWordsExceeded: true };
      }
      return null;
    };
  }
  // handleInput(event: Event): void {
  //   const inputValue: string = (event.target as HTMLInputElement).value;
  //   const wordCount: number = inputValue.trim().split(/\s+/).length;
  //   console.log("Tri------" , wordCount)
  //   if (wordCount > 3){console.log("Tri222------" )
  //     event.preventDefault();
  //   console.log("Tri1------")
  //   }
  // }

  viewMainCp(data: any) {
    this.requestFormService.getUploadedMainCp(data?.id, data.client).subscribe(
      (fileData: Blob) => {
        // Use the OverlapService to display the PDF
        this.overlayService.showPdf(fileData);
      },
      (error) => {
        this.toastr.info(ToasterMessages.RecordNotFount);
      },
    );
  }
  onRequestformFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedRequestformFile = input.files[0];
      console.log('Uploaded File Name:');
    }
    this.requestFormService.uploadFile(this.selectedRequestformFile).subscribe(
      (data) => {
        const res = data[data.length - 1];
        const ETAdate = res.etaDate.trim(); // Ensure no extra spaces
        const ETAhours = res.etaHours.split(':'); // Splitting time
        const cosp = data[0].etaDate.trim();
        const cospHours = res.etaHours.split(':');
        const client = this.selectedRequestformFile.name.split(/[_\s]/)[0];
        if (this.id) {
          if (res.ship === this.requestForm.get('ship')?.value) {
            this.requestForm.get('cosp')?.setValue(cosp); // Set the date
            this.requestForm.get('cospHours')?.setValue(cospHours[0]); // Set the hour
            this.requestForm.get('cospMinutes')?.setValue(cospHours[1]);
            this.setETA(res.eta_next_port_cp_ordered_speed);
            this.requestForm
              .get('cpOrderedSpeed')
              ?.setValue(res.cpOrderedSpeed);
            this.requestForm.get('cpFuel')?.setValue(res.cpGasOil);
            this.requestForm.get('reportedDate')?.setValue(ETAdate); // Set the date
            this.requestForm.get('reportedHours')?.setValue(ETAhours[0]); // Set the hour
            this.requestForm.get('reportedMinutes')?.setValue(ETAhours[1]);
            this.requestForm.get('repWindBf')?.setValue(res.repWindBf);
            this.requestForm.get('repSwell')?.setValue(res.repSwell);
            this.requestForm.get('repAvgSpeed')?.setValue(res.repAvgSpeed);
            this.requestForm.get('voyAvgSpeed')?.setValue(res.voyAvgSpeed);
            this.convertLatLong(res.lat, res.long);
          } else {
            this.toastr.warning(ToasterMessages.VesselMissMatch);
          }
        } else {
          this.requestForm.patchValue(res);
          const newFormulaVal = res?.useNewCurrentFormula || res?.usenewcurrentformula;
          if (newFormulaVal) {
            this.requestForm.get('useNewCurrentFormula')?.setValue(newFormulaVal);
          }
          this.requestForm.get('reportedDate')?.setValue(ETAdate); // Set the date
          this.requestForm.get('reportedHours')?.setValue(ETAhours[0]); // Set the hour
          this.requestForm.get('reportedMinutes')?.setValue(ETAhours[1]);
          this.requestForm.get('cpFuel')?.setValue(res.cpGasOil);
          this.requestForm.get('cpGasOil')?.setValue('');
          this.requestForm.get('cosp')?.setValue(cosp); // Set the date
          this.requestForm.get('cospHours')?.setValue(cospHours[0]); // Set the hour
          this.requestForm.get('cospMinutes')?.setValue(cospHours[1]);
          this.setETA(res.eta_next_port_cp_ordered_speed);
          this.requestForm.get('client')?.setValue(client);
          this.convertLatLong(res.lat, res.long);
        }
      },
      (error) => {
        this.toastr.warning(ToasterMessages.fileFormat);
      },
    );
  }
  setETA(etaString: string) {
    if (!etaString) return;

    // Remove 'LT' and split date & time parts
    const [datePart, timePart] = etaString.replace(' LT', '').split(' ');

    // Month mapping
    const months: { [key: string]: string } = {
      JAN: '01',
      FEB: '02',
      MAR: '03',
      APR: '04',
      MAY: '05',
      JUN: '06',
      JUL: '07',
      AUG: '08',
      SEP: '09',
      OCT: '10',
      NOV: '11',
      DEC: '12',
    };

    // Convert date format from "DD-MMM-YY" to "YYYY-MM-DD"
    const [day, monthAbbr, year] = datePart.split('-');
    const formattedDate = `20${year}-${months[monthAbbr]}-${day}`;

    // Extract hours and minutes
    const [hours, minutes] = timePart.split(':');

    // Set values to form fields
    this.requestForm.get('etaDate')?.setValue(formattedDate);
    this.requestForm.get('etaHours')?.setValue(hours);
    this.requestForm.get('etaMinutes')?.setValue(minutes);
  }
  convertLatLong(latStr: string, longStr: string) {
    let lat, latDir, long, longDir;

    // Ensure latStr and longStr are treated as strings
    const latString = latStr.toString();
    const longString = longStr.toString();

    // Convert Latitude
    if (latString.includes('N') || latString.includes('S')) {
      latDir = latString.includes('N') ? 'N' : 'S';
      lat = parseFloat(latString.replace(/[^\d.-]/g, '')); // Remove non-numeric characters and convert to float
      if (latDir === 'S') lat = -lat; // Convert to negative if South
    } else {
      lat = parseFloat(latString);
      latDir = lat >= 0 ? 'N' : 'S'; // Determine direction based on sign
      lat = Math.abs(lat); // Store absolute value in form
    }

    // Convert Longitude
    if (longString.includes('E') || longString.includes('W')) {
      longDir = longString.includes('E') ? 'E' : 'W';
      long = parseFloat(longString.replace(/[^\d.-]/g, '')); // Remove non-numeric characters and convert to float
      if (longDir === 'W') long = -long; // Convert to negative if West
    } else {
      long = parseFloat(longString);
      longDir = long >= 0 ? 'E' : 'W'; // Determine direction based on sign
      long = Math.abs(long); // Store absolute value in form
    }

    // Populate form fields
    this.requestForm.get('currLat')?.setValue(lat);
    this.requestForm.get('latDir')?.setValue(latDir);
    this.requestForm.get('currLng')?.setValue(long);
    this.requestForm.get('longDir')?.setValue(longDir);
  }
  addClick() {
    const dialog = this.dialog.open(PortsPopupComponent, {
      width: '600px',
      height: '400px',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      this.portDetails.getPortDetails().subscribe((response: any) => {
        this.filteredPortNames = response?.data ?? [];
      });
    });
  }

  toggleFormView() {
    this.isForm = !this.isForm;
  }

  getRouteDate(type: 'cosp' | 'eosp'): string {
    const rawDate = this.requestForm.get(type)?.value;
    if (!rawDate) return '';

    if (this.fileType === 'json') {
      return this.convertDropdownToDateTime(rawDate);
    } else {
      // Excel/Manual mode: Date is from date picker, time is in separate fields
      const dateStr = rawDate.toString(); // e.g. YYYY-MM-DD
      const hours = this.requestForm.get(type + 'Hours')?.value || '00';
      const minutes = this.requestForm.get(type + 'Minutes')?.value || '00';
      return dateStr + (hours && minutes ? ' ' + hours + ':' + minutes : '');
    }
  }

  convertDropdownToDateTime(value: string): string {
    if (!value) {
      return '';
    }

    // Expected format:
    // "PORT - Fri, 02 Jan 2026 15:00:00 GMT"
    // OR a direct date string from an already processed report like "2026-05-13 7:00"

    const parts = value.split(' - ');
    if (parts.length === 1) {
      return value; // It's already just a date string, return as is
    }

    const afterDash = parts[1];
    if (!afterDash) {
      return '';
    }

    // Create Date object (GMT is correctly parsed as UTC)
    const dateObj = new Date(afterDash);

    if (isNaN(dateObj.getTime())) {
      return '';
    }

    // Use UTC values (IMPORTANT)
    const yyyy = dateObj.getUTCFullYear();
    const mm = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(dateObj.getUTCDate()).padStart(2, '0');
    const hh = String(dateObj.getUTCHours()).padStart(2, '0');
    const min = String(dateObj.getUTCMinutes()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
  }

  openPopupOnce() {
    localStorage.setItem('fileType', this.fileType);

    if (this.fileType !== 'json') {
      return;
    }

    // 3️⃣ HARD GUARD → both must be selected

    const rawCosp = this.requestForm.get('cosp')?.value;
    const rawEosp = this.requestForm.get('eosp')?.value;
    if (!rawCosp || !rawEosp) {
      this.toastr.warning(
        'Please select both COSP and EOSP',
        'Missing selection',
      );
      return;
    }
    let payload = {
      imo_number: this.requestForm.get('imoNumber')?.value || '',
      start_date: this.getRouteDate('cosp'),
      end_date: this.getRouteDate('eosp'),
    };
    const dialogRef = this.dialog.open(FormPopupComponent, {
      width: '1087px',
      height: '500px',
      disableClose: true,
      data: payload,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dataToPass = result;
      }
    });
  }
}
